__turbopack_context__.v({
  "footer": "bU2TmW_footer",
});
